/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { get } from "lodash";
import Button from "../../../components/Button";
import Filters from "../../../components/Filters";
import Modal, { ModalHeader } from "../../../components/Modal";
import { ControlTable } from "../../../components/Table";
import { getParams } from "../../../utils/params";
import systemAlert from "../../../utils/systemAlert";
import { isEmpty } from "../../../utils/lodashExtend";
import useForm from "../../../hooks/useForm";
import { mappingTaxInvoiceClient } from "../../../apis/invoices";
import { getClientsList } from "../../../apis/finances/bank";
import { modifyCashReceiptsClients } from "../../../apis/cash-receipts";

export const CLIENT_SEARCH_OPTIONS = [
  { label: "거래처명", value: "name" },
  { label: "대표자명", value: "ceoName" },
]

const defaultForm = {
  searchType: "name",
  searchText: "",
  page: 0,
  limit: 10,
  type: ["company"]
};

const TaxInvoiceClientMapping = ({ open, setOpen, data, setData, submit, type, invoiceType }) => {
  const [fields] = useState([
    { title: "거래처명", key: "name" },
    { title: "거래처코드", key: "companyAccount.code" },
    { title: "대표자명", key: "companyAccount.ceoName" },
    {
      title: "구분",
      key: "companyAccount.type",
      onTranslator: {
        list: [
          {
            label: "사업자",
            value: 0,
          },
          {
            label: "개인",
            value: 1,
          },
          {
            label: "외국인",
            value: 2,
          },
        ],
      },
    },
    { title: "사업자등록번호", key: "companyAccount.comNum", transform: 'comNum' },
    { title: "주소", key: "companyAccount.address" },
    { title: "전화번호", key: "companyAccount.mobile" },
  ]);
  const [filters] = useState([
    {
      title: "분류",
      type: "select",
      key: "searchType",
      options: {
        list: CLIENT_SEARCH_OPTIONS,
      },
    },
    {
      title: "키워드 검색",
      type: "input",
      key: "searchText",
      placeholder: "검색어 입력",
    },
  ]);

  const {
    values,
    setValues,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list,
    setList,
    selectedData,
    setSelectedData,
    isLoading,
    setIsLoading,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
  } = useForm(defaultForm);

  useEffect(() => {
    _submit(values);
    setSubmit(_submit);
  }, []);

  const _submit = (params) => {
    setIsLoading(true);
    getClientsList({
      ...getParams(params),
    })
      .then((res) => {
        setTotal(get(res, "data.totalCount"));
        setList(get(res, "data.clientList"));
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const cancel = () => {
    setSelectedData({});
    setData(null)
    setValues(defaultForm);
    setOpen(false);
  };

  const handleOnSupply = () => {
    if (isEmpty(selectedData)) return systemAlert("거래처를 선택해주세요.");
    switch (invoiceType)
    {
      case "cash-invoice":
        systemAlert('해당 현금영수증에 거래처를 매핑 하시겠습니까?', {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                modifyCashReceiptsClients(type, data.idx, selectedData.idx).then(() => {
                  submit();
                  cancel();
                })
              }
            }
          ]
        })
        break;
      default:
        systemAlert('해당 세금계산서에 거래처를 매핑 하시겠습니까?', {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                mappingTaxInvoiceClient(data.idx, selectedData.idx).then(() => {
                  submit();
                  cancel();
                })
              }
            }
          ]
        })
        break;
    }
  };

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="select-client-info">
        <ModalHeader>거래처 매핑하기</ModalHeader>
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={values}
          onChange={handleOnChange}
        />
        <ControlTable
          isLoading={isLoading}
          isSelect
          setSelectedData={setSelectedData}
          fields={fields}
          list={list}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          submit={handleSubmit}
        />
        <div className="submit-button-wrap float-right margin-top-32">
          <Button
            className="button"
            size="lg"
            label="취소"
            color="text"
            action={cancel}
          />
          <Button
            className="button"
            size="lg"
            label="적용하기"
            action={handleOnSupply}
          />
        </div>
      </div>
    </Modal>
  );
};

export default TaxInvoiceClientMapping;
